import { render, staticRenderFns } from "./SeqkitStatsSetup.vue?vue&type=template&id=25c9fe1e"
import script from "./SeqkitStatsSetup.vue?vue&type=script&lang=ts"
export * from "./SeqkitStatsSetup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports